import React from 'react'
import CityLogo from '../../img/city-logo-2.svg';
import Logo from '../../img/sa-enkelt-logo.svg';

const { REACT_APP_BRAND } = process.env;

const DashboardFooter = () => {
  return (
    <footer id='dashboard-footer' className='flex items-center justify-center'>
      {REACT_APP_BRAND === 'CITY'
        ? <img src={CityLogo} alt="City Logo" />
        : <img src={Logo} alt="Sa Enkelt Logo" />
      }
    </footer>
  )
}

export default DashboardFooter
